import React, { useState, useRef, useEffect } from "react";
import {
  SpeakerNotesOutlined,
  ExpandMoreOutlined,
  ExpandLessOutlined,
} from "@mui/icons-material";
import { getFormattedDate } from "utils/date";
import { DATE_FORMAT } from "static/date";

const titleStyle = {
  fontFamily: "Roboto",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "100%",
  letterSpacing: "0%",
  color: "#175EC8",
};

const contentStyle = {
  fontFamily: "Roboto",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "100%",
  letterSpacing: "0%",
  color: "#212121",
};

const dateStyle = {
  fontFamily: "Roboto",
  fontWeight: 400,
  fontSize: "12px",
  color: "#949494",
  marginTop: "4px",
  marginBottom: "4px",
};

const dateSeparatorStyle = {
  margin: "0 4px",
};

const toggleStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: "2px",
  fontFamily: "Roboto",
  fontWeight: 500,
  fontSize: "12px",
  color: "#94BA33",
  cursor: "pointer",
  background: "none",
  border: "none",
  padding: 0,
  marginTop: "10px",
};

const LINE_CLAMP = 3;

const TaskCommunicationNote = ({
  content,
  action,
  addedAt,
  onExpand,
  onCollapse,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const clampedRef = useRef(null);
  const fullRef = useRef(null);

  useEffect(() => {
    if (clampedRef.current && fullRef.current) {
      setIsOverflowing(
        fullRef.current.offsetHeight > clampedRef.current.offsetHeight
      );
    }
  }, [content]);

  return (
    <div
      style={{
        background: "#F5F7FB",
        border: "1px solid #CAD7EC",
        padding: "8px",
        borderRadius: "4px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
          marginBottom: "4px",
        }}
      >
        <SpeakerNotesOutlined style={{ color: "#175EC8", fontSize: "16px" }} />
        <span style={titleStyle}>Communication Notes</span>
        {action && (
          <div style={{ marginLeft: "auto", whiteSpace: "nowrap" }}>
            {action}
          </div>
        )}
      </div>
      {/* Hidden unclamped span to measure full height */}
      <span
        ref={fullRef}
        aria-hidden
        style={{
          ...contentStyle,
          position: "absolute",
          visibility: "hidden",
          pointerEvents: "none",
          lineHeight: "1.4em",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
        }}
      >
        {content}
      </span>
      <span
        ref={clampedRef}
        style={{
          ...contentStyle,
          display: "block",
          maxHeight: expanded ? "none" : `calc(${LINE_CLAMP} * 1.4em)`,
          overflow: "hidden",
          lineHeight: "1.4em",
          wordBreak: "break-word",
          whiteSpace: "pre-wrap",
        }}
      >
        {content}
      </span>
      {isOverflowing && !expanded && (
        <span
          style={{
            fontFamily: "Roboto",
            fontWeight: 400,
            fontSize: "14px",
            color: "#212121",
          }}
        >
          ....
        </span>
      )}
      {addedAt && (
        <div style={{ marginTop: "4px" }}>
          <span style={dateStyle}>
            {getFormattedDate(addedAt, DATE_FORMAT.DEFAULT)}
            <span style={dateSeparatorStyle}>·</span>
            {getFormattedDate(addedAt, DATE_FORMAT.SHORT_TIME)}
          </span>
        </div>
      )}
      {(isOverflowing || expanded) && (
        <button
          style={toggleStyle}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            setExpanded((v) => {
              const next = !v;
              if (next) onExpand?.();
              else onCollapse?.();
              return next;
            });
          }}
        >
          {expanded ? (
            <>
              Show less <ExpandLessOutlined style={{ fontSize: "14px" }} />
            </>
          ) : (
            <>
              Show more <ExpandMoreOutlined style={{ fontSize: "14px" }} />
            </>
          )}
        </button>
      )}
    </div>
  );
};

export default TaskCommunicationNote;
